import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export type SampleFormValues = {
  name: string;
  description: string;
  predicate: {
    dsl: string;
    dslHuman: string;
  };
  conversationIds: number[];
};

export const useSampleSchema = () => {
  const { t } = useTranslation('common');

  return useMemo(
    () =>
      z.object({
        name: z.string().min(1, t('required')),
        description: z.string(),
        predicate: z.object({
          dsl: z.string(),
          dslHuman: z.string(),
        }),
        conversationIds: z.array(z.number()),
      }),
    [t],
  );
};
